import { environment } from '../environments/environment';

export const isEnv = (...env: string[]): boolean => {
  const currentEnv = environment.environmentName;
  return env.includes(currentEnv);
};
